import { CaptionsTool } from '@/components/CaptionsTool';

const CaptionsPage = () => {
  return <CaptionsTool />;
};

export default CaptionsPage;
